export default "__VITE_ASSET__EPNhZqs8__"